import { observer } from 'mobx-react-lite';
import moment from 'moment';
import * as React from 'react';

import { useGetReferralCode } from '../../figma/ReferralShare/useGetReferralCode';
import { ExpiredPromotion, ExpireSoonPromotion, RegisterAccPromotion } from './DolPremiumBanner';
import { RegisterCoursePromotion } from './RegisterCoursePromotion';
import { useGetAuthInfo } from '@doltech/core/lib/auth/withGlobalUserAuthInfo';

const isExpireSoon = (expiredAt: string) => {
  const daysLeft = moment(expiredAt).diff(moment(), 'days');
  return daysLeft >= 0 && daysLeft <= 3;
};

interface DolPremiumPromotionProps {
  hasImage?: boolean;
  vertical?: boolean;
}

const DolPremiumPromotionBase = ({
  hasImage = true,
  vertical = false,
}: DolPremiumPromotionProps) => {
  const { isLoggedIn } = useGetAuthInfo();
  const { query } = useGetReferralCode();
  const isExpired = query?.data?.data?.dpStatus === 'EXPIRED';
  const expireAt = query?.data?.data?.dpExpireAt;

  if (!isLoggedIn) {
    return <RegisterAccPromotion hasImage={hasImage} vertical={vertical} />;
  }

  if (isExpired) {
    return <ExpiredPromotion hasImage={hasImage} vertical={vertical} />;
  }

  if (expireAt && isExpireSoon(expireAt)) {
    return <ExpireSoonPromotion expireAt={expireAt} hasImage={hasImage} vertical={vertical} />;
  }

  return <RegisterCoursePromotion />;
};

export const DolPremiumPromotion = observer(DolPremiumPromotionBase);
